import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../../utils";
import PageSubheader from "../../../../../components/PageSubheader";
import QuoteRequestStatusForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateQuoteRequestStatus = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.quote.request.status.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-quote-request-status-create"
        goBackURL={backURL}
      />

      <QuoteRequestStatusForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateQuoteRequestStatus));
